/**
 * A JSON object: not null, not an array. The one guard every merge, patch and per-environment
 * walk agrees on. No imports — the client bundles the modules that use it.
 */
export const isPlainObject = (v: unknown): v is Record<string, unknown> =>
    v !== null && typeof v === 'object' && !Array.isArray(v);
